import React, { useState } from 'react';
import moment from 'moment';

import { DatePicker } from 'Components/Admin/Form/Fields';

const SetDate = ({ onClose }) => {
  const [selectedDay, setSelectedDay] = useState(null);

  const periods = [
    { type: 'today', title: 'Today' },
    { type: 'tomorrow', title: 'Tomorrow' },
    { type: 'inMonth', title: 'In a month' },
    { type: 'inYear', title: 'In a year' },
  ];

  const handleSelectDay = (type) => {
    const periodsValue = {
      today: moment().toDate(),
      tomorrow: moment().add(1, 'days').toDate(),
      inMonth: moment().add(1, 'months').toDate(),
      inYear: moment().add(1, 'years').toDate(),
    };

    setSelectedDay(periodsValue[type] || null);
  };

  return (
    <div className="set-date" data-testid="set-date-menu">
      <div className="set-date__left">
        <div className="set-date__title">End date of work period</div>
        <div className="set-date__description">Specify the end date of the work period for the selected employee</div>
        <div className="set-date__periods">
          {
            periods.map(({ type, title }) => (
              <button key={type} onClick={handleSelectDay.bind(null, type)}>{title}</button>
            ))
          }
        </div>
      </div>
      <div className="set-date__right">
        <DatePicker
          isAlwaysOpened
          onClose={onClose}
          fieldProps={
            { onChange: setSelectedDay, value: selectedDay }
          }
        />
      </div>
    </div>
  );
};

export default SetDate;
